import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { useTranscriptContextValue } from '../context/TranscriptProvider'

const ACTOR_LABEL: Record<'user' | 'bot', string> = {
  user: 'Worker',
  bot: 'Agent',
}

export const TranscriptMain = () => {
  const {
    state: { turns },
  } = useTranscriptContextValue()

  if (turns.length === 0) {
    return <Text color="lightText">No dialog found in transcript.</Text>
  }

  return (
    <Box>
      {turns.map((turn, index) => {
        const isWorker = turn.role === 'user'
        return (
          <Flex
            key={`${turn.role}-${index}`}
            flexDirection="column"
            alignItems={isWorker ? 'flex-end' : 'flex-start'}
            mt={index === 0 ? 0 : 2}
          >
            <Text fontSize={1} color="lightText" mb={1}>
              {ACTOR_LABEL[turn.role]}
            </Text>
            <Box
              width="fit-content"
              maxWidth="85%"
              borderRadius="standard"
              backgroundColor={isWorker ? 'primary50' : 'offWhite50'}
              p={2}
              ml={isWorker ? 4 : 0}
              mr={isWorker ? 0 : 4}
            >
              {turn.contents.map((content, contentIndex) => (
                <Text
                  key={contentIndex}
                  color="body"
                  textAlign={isWorker ? 'right' : 'left'}
                  style={{ whiteSpace: 'pre-wrap' }}
                  mt={contentIndex === 0 ? 0 : 2}
                >
                  {content}
                </Text>
              ))}
            </Box>
          </Flex>
        )
      })}
    </Box>
  )
}
